module.exports = __webpack_public_path__ + "static/ira-383059eff05cd654b596a324b0aa4684.png";